import React, { Component } from 'react';
import commonUtil from '../../../../../utils/commonUtil';
import Warning from '../../../../../components/Warning';

export default class GiftRegistryHeader extends Component {
  constructor(props) {
    super(props);
    this.warningMessage = null;
  }

  validated(selectaddress) {
    let noAddress = true;
    if (selectaddress) {
      this.warning.setMessage(commonUtil.getLabel(this.props.lables.createEventStep3, 'createEventStep3.noDeliveryAddress.errorMessage'));
    }
    if (this.props.addressBook.status.status === 'failure') {
      noAddress = false;
      this.warning.setMessage(this.props.addressBook.status.errorMessage);
    }
    if(this.props.warningMessage){
      noAddress = false;
      this.warning.setMessage(this.props.warningMessage);
    }
    return noAddress;
  }
  render() {
    const { user, lables } = this.props;
    return (
      <React.Fragment>
        <div className="registerTitles">
          {/* <h2 className="registerGiftTitle">{user && user.firstName ? user.firstName : ''},</h2>&nbsp;
          <h2 className="registerGiftSubTitle">{ commonUtil.getLabel(this.props.lables.createEventStep3, 'createEventStep3.select.deliveryaddressforgifts.message')}</h2> */}
        </div>
        {
          this.props.isWap ? <p className={`registerGiftText newFontSize`}>
          Ingresa hasta dos direcciones para recibir tus regalos. Recuerda que una vez guardadas, solo podrás cambiarlas en tienda.
        </p> : (<div className='newTextContainer'>
          <p className={`registerGiftText newFontSize`}>
          {/* {commonUtil.getLabel(lables.createEventStep3, 'createEventStep3.selectaddress.message')}<br />
          {this.props.prioritiesOptions && this.props.prioritiesOptions.length === 1 && commonUtil.getLabel(this.props.lables.createEventStep3, 'createEventStep3.selectaddress.forOneCelebrated')}
          {this.props.prioritiesOptions && this.props.prioritiesOptions.length === 2 && commonUtil.getLabel(this.props.lables.createEventStep3, 'createEventStep3.selectaddress.forTwoCelebrated')}
          {this.props.prioritiesOptions && this.props.prioritiesOptions.length === 3 && commonUtil.getLabel(this.props.lables.createEventStep3, 'createEventStep3.selectaddress.forThreeCelebrated')} */}
          Ingresa hasta dos direcciones para recibir tus regalos. Recuerda que una vez guardadas, solo </p>
          <p className='text-center second_txt_header_address'>podrás cambiarlas en tienda.</p>
          </div>)
        }
        
        <div>
          <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
        </div>
      </React.Fragment>
    );
  }

}
// createEventStep3.selectaddress.message
//  commonUtil.getLabel(this.props.lables.createEventStep3, 'createEventStep3.selectaddress.forOneCelebrated')
// commonUtil.getLabel(this.props.lables.createEventStep3, 'createEventStep3.selectaddress.forTwoCelebrated')
// commonUtil.getLabel(this.props.lables.createEventStep3, 'createEventStep3.selectaddress.forThreeCelebrated')
